import React from 'react'

const Offers = () => {
  return (
    <div className='max-w-[900px] mx-auto px-4 py-10 flex flex-wrap justify-between '>
        <p className='capitalize text-lg font-bold text-gray-700'>Booking incentives</p>
        <p className='capitalize text-lg font-bold text-gray-700'>Competative rates</p>
        <p className='capitalize text-lg font-bold text-gray-700'>book with flexibility</p>
        <p className='capitalize text-lg font-bold text-gray-700'>trip insurance</p>
    </div>
  )
}

export default Offers